import PropTypes from 'prop-types'

/**
 * @typedef {Object} stpParkingProviders
 *
 * @property {string}  [name]   - secure truck parking provider name
 */
export const stpParkingProvidersPropType = PropTypes.shape({
    name: PropTypes.string.isRequired
})
